import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Block, Close, Feedback, Info, NewReleases } from '@material-ui/icons'
import * as contentful from 'contentful'
import React, { useEffect, useState } from 'react'
import { CookiesProvider, useCookies } from 'react-cookie'
import styled from 'styled-components'

import { Notification as NotificationType } from '../../models/notification'
import theme from '../atoms/theme'

const { colours } = theme

type NotificationPropTypes = {
  isMenuActive?: boolean
  layoutNotification: (b: boolean) => void
}

const NotificationContainer = styled.div`
  background-color: ${colours.primary};
  padding: 2rem;
  background-color: ${(props): string => (props.colour ? props.colour : colours.primary)};
  color: ${colours.light};
  display: flex;
  align-items: center;

  @media only screen and ${theme.breakpoints.fromNormalScreen} {
    padding: 3.4rem;
  }

  p {
    margin: 0;
  }
`

const Notifications = styled.div`
  display: ${(props): string => (props.isMenuActive ? 'none' : 'block')};
`

const StyledClose = styled(Close)`
  cursor: pointer;
  font-size: 3.4rem;
`

const NotificationContent = styled.div`
  flex-grow: 1;
  margin: 0 2rem;
`

const Notification = (props: NotificationPropTypes): JSX.Element => {
  const [cookies, setCookie] = useCookies(['closedNotifications'])
  const [closedNotificationsArray, setClosedNotificationArray] = useState(
    cookies.closedNotifications || [],
  )
  const [notifications, setNotifications] = useState([])

  useEffect(() => {
    const client = contentful.createClient({
      space: 'mplktqcfflsk',
      accessToken: '33pZAAGx603kjjSnwqTceJ3oJQgh18dnz4yIL8jVEuw',
    })

    client
      .getEntries({
        // eslint-disable-next-line @typescript-eslint/camelcase
        content_type: 'notification',
      })
      .then((response) => setNotifications(response.items))
      .catch(console.error)
  }, [])

  useEffect(() => {
    if (
      notifications &&
      notifications.length > 0 &&
      (!closedNotificationsArray || closedNotificationsArray.length === 0)
    ) {
      props.layoutNotification(true)
    } else if (
      notifications &&
      notifications.length > 0 &&
      closedNotificationsArray
    ) {
      const areAnyNotificationsUnclosed = notifications.some(
        (notification) =>
          !closedNotificationsArray.includes(notification.sys.id),
      )
      props.layoutNotification(areAnyNotificationsUnclosed)
    } else {
      props.layoutNotification(false)
    }
  }, [closedNotificationsArray, notifications, props.layoutNotification])

  const handleClose = (notificationID): void => {
    if (closedNotificationsArray.indexOf(notificationID) === -1) {
      setClosedNotificationArray((oldArray) => [...oldArray, notificationID])
      setCookie(
        'closedNotifications',
        JSON.stringify([...closedNotificationsArray, notificationID]),
        { path: '/' },
      )
    }
  }

  const renderNotifications = notifications.map(
    (notification: NotificationType) => {
      if (
        Array.isArray(closedNotificationsArray) &&
        closedNotificationsArray.length > 0 &&
        closedNotificationsArray.includes(notification.sys.id)
      ) {
        return null
      }

      let notificationColour = colours.dark
      let notificationIcon = <Info style={{ fontSize: '3.4rem' }} />

      switch (notification.fields.notificationType) {
        case 'Urgent (Red)':
          notificationColour = colours.warning
          notificationIcon = <Block style={{ fontSize: '3.4rem' }} />
          break

        case 'Info (Blue)':
          notificationColour = colours.info
          notificationIcon = <Feedback style={{ fontSize: '3.4rem' }} />
          break

        case 'Success (Green)':
          notificationColour = colours.success
          notificationIcon = <NewReleases style={{ fontSize: '3.4rem' }} />
          break

        default:
          break
      }

      return (
        <NotificationContainer
          key={notification.sys.id}
          colour={notificationColour}
        >
          {notificationIcon}
          <NotificationContent>
            {documentToReactComponents(notification.fields.content)}
          </NotificationContent>
          <StyledClose
            style={{ fontSize: '3.4rem' }}
            onClick={(): void => handleClose(notification.sys.id)}
          />
        </NotificationContainer>
      )
    },
  )

  return (
    <CookiesProvider>
      <Notifications isMenuActive={props.isMenuActive}>
        {renderNotifications}
      </Notifications>
    </CookiesProvider>
  )
}

export default Notification
